import {Button, Card, Form, Icon, Input, message, Select, Spin, Table, Tag} from 'antd';
import React from "react";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";
import SubList from "../../components/ComplaintSubList";

import './style.css'

const EditableContext = React.createContext();

const EditableRow = ({form, index, ...props}) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);
const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  state = {
    editing: false,
  };

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({editing}, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  save = e => {
    const {record, handleSave} = this.props;
    this.form.validateFields((error, values) => {
      if (error && error[e.currentTarget.id]) {
        return;
      }
      this.toggleEdit();
      handleSave({...record, ...values});
    });
  };

  renderCell = form => {
    this.form = form;
    const {children, dataIndex, record, title} = this.props;
    const {editing} = this.state;
    return editing ? (
      <Form.Item style={{margin: 0}}>
        {form.getFieldDecorator(dataIndex, {
          rules: [
            {
              required: true,
              message: `${title} is required.`,
            },
          ],
          initialValue: record[dataIndex],
        })(<Input ref={node => (this.input = node)} onPressEnter={this.save} onBlur={this.save}/>)}
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{paddingRight: 24}}
        onClick={this.toggleEdit}
      >
        {children}
      </div>
    );
  };

  render() {
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      children,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editable ? (
          <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
        ) : (
          children
        )}
      </td>
    );
  }
}

// ======

class Create extends React.Component {

  state = {
    searchedTask: [],
    selectedTask: new Set(),
    selectedTaskList: [],
  }

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      const {tasks} = nextProps.data;
      // console.log(tasks);
      this.setState({
        selectedTaskList: tasks
      })
    }
  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      // values.tasks = this.state.selectedTaskList.map(task => {
      //   return {task: task._id, instruction: task.instruction || ''}
      // });
      values.tasks = this.state.selectedTaskList;
      console.log(values)
      if (values.tasks && values.tasks.length) {
        // console.log(values);
        if (match.params && match.params.id) {
          this.props.onSubmit(values, match.params.id);
        } else {
          this.props.onSubmit(values);
        }
      } else message.error(`Tasks not added!`)
    });
  };

  handleSelectTask = (val) => {
    const set = this.state.selectedTask;
    set.add(val);
    // console.log(val, set);
    this.setState({selectedTask: set});
    const taskList = this.state.searchedTask;
    let selectedTaskList = this.state.selectedTaskList;
    // console.log(taskList, selectedTaskList)
    const d = taskList.filter(tsk => '' + tsk._id === val)[0];
    selectedTaskList = [...selectedTaskList, {task: d, instruction: d.instruction || ''}];
    this.setState({selectedTaskList: selectedTaskList});
  }

  handleTaskSearchModel = (key) => {
    if (key.length > 2) {
      // console.log(this.props.filters['tasks']['schema']['task'])
      this.setState({
        searchedTask: (this.props.filters['tasks'] && this.props.filters['tasks']['schema'] && this.props.filters['tasks']['schema']['task']
          && this.props.filters['tasks']['schema']['task'].data && this.props.filters['tasks']['schema']['task'].data.data || []).filter(task => {
          const name = task.taskName.toLowerCase();
          const code = task.taskCode.toLowerCase();
          return (name.indexOf(key.toLowerCase()) !== -1 || code.indexOf(key.toLowerCase()) !== -1);
        })
      });
      // this.props.onTaskSearch(key);
    }
  }

  taskCols = () => {
    return [
      {
        title: 'Code',
        dataIndex: 'taskCode',
        key: 'taskCode',
        width: '10%',
        render: (_, record) => record.task && record.task.taskCode
      },
      {
        title: 'name',
        dataIndex: 'taskName',
        key: 'taskName',
        width: '20%',
        render: (_, record) => record.task && record.task.taskName
      },
      {
        title: 'Instruction',
        dataIndex: 'instruction',
        key: 'instruction',
        editable: true,
        width: '40%',
        // render: (_, record) => record.instruction || (record.task && record.task.instruction)
      },
      {
        title: 'Skippable',
        dataIndex: 'allowToSkip',
        key: 'allowToSkip',
        width: '10%',
        render: (item, record) => (record.task && record.task && record.task.allowToSkip) ? 'Yes' : 'No',
      },
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        align: 'right',
        width: '20%',
        render: (_, record, index) =>
          <>
            <Button title={'Remove from list'} type="danger" size="small"
                    onClick={this.removeFromTaskList.bind(this, record._id || record.task._id)}>
              <Icon type="close"/>
            </Button>
            <Button title={'Add Spare'} type="button" size="small" icon={'setting'}>Spares</Button>
            <Button title={'Add Manpower'} type="button" size="small" icon={'tag'}>Manpower</Button>
          </>
      }
    ];
  }

  removeFromTaskList = (taskId) => {
    const list = this.state.selectedTaskList;
    this.setState({selectedTaskList: list.filter(item => item.task._id !== taskId)});
  }

  handleSave = row => {

    const newData = [...this.state.selectedTaskList];
    // console.log(row, newData);
    const index = newData.findIndex(item => row.task._id === item.task._id);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    // console.log(newData);
    this.setState({selectedTaskList: newData});
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, form, searchedTask} = this.props;
    const taskSet = this.state.selectedTask;
    const commonFormFieldDetails = {
      title: this.props.title,
      resource,
      hideMasterForFields: this.props.title === 'CREATE' ? ['assetModel', 'model'] : []
    };

    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };

    const columns = this.taskCols().map(col => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
        }),
      };
    });

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${'PM Schedule'}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">
            {Object.keys(filters).map((item) => {
              if (filters[item].type === 'Array' && filters[item].schema && item !== 'tasks') {
                // console.log(data[item]);
                return <SubList key={item} item={filters[item]} form={form} data={data && data[item]} title={title}
                                resource={resource}/>
              } else {
                if (item === 'serviceIdentifierNo' || item === 'serviceIdentifierName') {
                  if (this.props.title === 'EDIT')
                    return getFormFieldByType(filters, item, getFieldDecorator, data, commonFormFieldDetails);
                  else return null;
                } else if (item === 'tasks') {
                  return (
                    <Form.Item key={item} label={sanitizeFieldName(item)}>
                      {getFieldDecorator(item, {
                        rules: [
                          {required: false, message: `${item} is required!`}
                        ],
                        // initialValue: data && data[item]
                      })(
                        <Select
                          mode="single"
                          showSearch
                          allowClear
                          style={{width: "100%"}}
                          placeholder="Please select"
                          optionLabelProp="label"
                          onSearch={this.handleTaskSearchModel}
                          notFoundContent={this.props.loading ? <Spin size="small"/> : null}
                          filterOption={false}
                          // filterOption={(input, option) =>
                          //   (option.props.label + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                          // }
                          onChange={this.handleSelectTask}
                        >
                          {this.state.searchedTask.map(itm => (
                            <Select.Option disabled={taskSet.has(itm._id)} key={itm._id} value={itm._id}
                                           label={itm.taskCode}>
                              <div>
                                <>
                                  <Tag color="blue">{itm.taskCode}</Tag>
                                  <Tag color="purple">{itm.taskName}</Tag>
                                </>
                              </div>
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                  );
                } else return getFormFieldByType(filters, item, getFieldDecorator, data, commonFormFieldDetails)
              }
            })}

            <Table dataSource={this.state.selectedTaskList} columns={columns} pagination={false}
                   components={components}
                   rowClassName={() => 'editable-row'} bordered/>

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
